import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { YearEndRxUnfinishedValueDto } from "../../../../api-client";

interface ColumnNameConfig<T> {
  header: string;
  field: keyof T; 
  align?: "left" | "right" | "center";
  format?: (val: T[keyof T]) => string | number;
  csvFormat?: (val: T[keyof T]) => string; 
};

interface TableProps {
  yearEndRxData: YearEndRxUnfinishedValueDto[];
  columns: ColumnNameConfig<YearEndRxUnfinishedValueDto>[];
  isLoading: boolean;
}

const YearEndRxUnfinishedValueTable = ({ yearEndRxData, columns, isLoading }: TableProps) => {
  return (
    <TableContainer
      className="year-end-rx-value-table"
      component={Paper}
      elevation={0}
      sx={{
        backgroundColor: "white",
        pb: 0,
        height: "100%",
        overflowX: "auto",
        flexGrow: 1,
      }}
    >
      <Table sx={{ minWidth: "max-content" }}>
        <TableHead className="year-end-rx-value-table-header">
          <TableRow>
            {columns.map((col) => {
              return (
                <TableCell key={String(col.field)} align={col.align}>
                  {col.header}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            Array.from({ length: 3 }).map((_, idx) => (
              <TableRow key={idx}>
                {columns.map((col) => (
                  <TableCell
                    key={String(col.field)}
                    align={col.align}
                  >
                    <Skeleton animation="wave" variant="text" width="100%" />
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : yearEndRxData.length === 0 ? (
            <TableRow>
              <TableCell colSpan={columns.length} align="center">
                Keine Daten
              </TableCell>
            </TableRow>
          ) : (
            yearEndRxData.map((row) => (
              <TableRow className="year-end-rx-value-table-row" key={row.accountId}>
                {columns.map(col => (
                    <TableCell key={col.field} align={col.align}>
                        {col.format ? col.format(row[col.field]) : row[col.field]}
                    </TableCell>
                ))}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default YearEndRxUnfinishedValueTable;
